import { IconSvgProps } from "../types";

export const OpenLock = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        id="icon-object-openlock"
        viewBox="0 0 22 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M7 14L7 8C7 5.79086 8.79086 4 11 4C13.2091 4 15 5.79086 15 8H19C19 3.58172 15.4183 0 11 0C6.58172 0 3 3.58172 3 8L3 14H0V30H22V14H7Z"
            fill="#1868DB"
        />
    </svg>
);
